"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('toggleAgenda')(legacy_1.select({
    store: function () { return store_1.default; },
})(function toggleAgenda(state) {
    state.store.isAgendaOpen = !state.store.isAgendaOpen;
}));
//# sourceMappingURL=toggleAgenda.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-upnext/lib/actions/toggleAgenda.js
// module id = 4827
// module chunks = 48